import { request } from '../request'

// 条件查询（分页）
export function getAnswerList(params) {
  return request({
    url: '/answer/answer/search',
    method: 'get',
    params: params
  })
}

export function fetchList(params) {
  return request({
    url: '/answer/answer/load/' + params,
    method: 'get'
  })
}

// 查询答题通道/督导任务列表
export function channelList(params) {
  return request({
    url: '/answer/answer/answerChannel?channel=' + params,
    method: 'get'
  })
}
// 新版查询子渠道 2020/06/18
export function subChannel(channel, surveyId) {
  return request({
    url: '/answer/answer/subChannel',
    method: 'get',
    params: {
      channel,
      surveyId
    }
  })
}

// 查询质控人
// http://docs.jianchaba.com/project/220/interface/api/28322
export function getAnswerUserList(params) {
  return request({
    url: '/answer/answer/userList',
    method: 'get',
    params
  })
}

export function getAnswerAddressInfo(id) {
  const answerIds = Array.isArray(id) ? id : [id]
  return request.post('/fill/wjlocation/batchGetByAnswerIds', answerIds).then(res => {
    if (res.data.code !== 0) return null
    const data = res.data.data
    return Array.isArray(id) ? data : (data[0] || null)
  }).catch(() => null)
}

// 查询详情
export function detail(params) {
  return request({
    url: '/answer/answer/detail/' + params,
    method: 'get'
  })
}

/**
 * 上传模版数据
 * @param data
 * @return {Promise}
 */
export function importTemplateData(data) {
  return request({
    url: '/answer/answer/import',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

/**
 * 获取导入模板
 * @param params
 * @return {data:link}
 */
export function getImportTemplateIds(params) {
  return request({
    url: '/answer/answer/importTemplateIds/',
    method: 'GET',
    params
  })
}

// 导出
export function dcExl(params) {
  return request({
    url: '/answer/answer/export/' + params,
    method: 'GET',
    responseType: 'blob'
  })
}

// 导出答卷数据
export function dcExlList(data) {
  return request({
    url: '/answer/answer/getanswer',
    method: 'GET',
    params: data
  })
}
// 导出答卷 pro2.0（导出序号+文本）
export function exportAnswers(data) {
  return request({
    url: '/answer/answer/export/',
    method: 'POST',
    data
  })
}
// 导出答卷 pro2.0 (选择题按序号导出)
export function exportAnswerIds(data) {
  return request({
    url: '/answer/answer/exportIds/',
    method: 'POST',
    data
  })
}
// 导出答卷exportSPSS
export function exportSPSS(data) {
  return request({
    url: '/answer/answer/exportSPSS/',
    method: 'POST',
    data
  })
}
// 开放题修改记录
export function modify(data) {
  return request({
    url: '/answer/answerAuditLog/page',
    method: 'GET',
    params: data
  })
}

export function downloadMedia(data) {
  return request({
    url: '/answer/answer/downloadMedia',
    method: 'POST',
    data
  })
}

//查询答案相关的enum取值 /answer/answer/getEnumValues
export function getEnumValues(params) {
  return request({
    url: '/answer/answer/getEnumValues',
    method: 'GET',
    params
  })
}

export function getPasswordInfo(params) {
  return request({
    url: '/wenjuan/wjsurveyPassword/info',
    method: 'GET',
    params
  })
}

export function getAudioText(params) {
  return request({
    url: '/fill/api/v1/getAudioText',
    method: 'GET',
    params
  })
}

//查询问卷导出记录
export function surveyExportRecord(params) {
  return request({
    url: '/answer/answer/surveyExportRecord',
    method: 'GET',
    params
  })
}

// 录音转文字
export function audioToText(params) {
  return request({
    url: '/answer/answer/speechFlashRecognizer',
    method: 'GET',
    params
  })
}